export const PLANNING_APPS_LAYER_TYPE_ID = "PLANNING_APPLICATIONS";
export const PLANNING_APPS_RECENT_SUMMARY_LAYER_TYPE_ID = "PLANNING_APPLICATIONS__RECENT_SUMMARY";
